"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProductReview = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var R = _interopRequireWildcard(require("ramda"));

var _marketplace = require("../store/marketplace/marketplace.selector");

var _marketplace2 = require("../store/marketplace/marketplace.actions");

/**
 * Product review hook.
 *
 * @returns {Object} - Product interface.
 */
var useProductReview = function useProductReview() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var isLoading = (0, _reactRedux.useSelector)(_marketplace.getMarketplaceIsLoading);
  var details = (0, _reactRedux.useSelector)(_marketplace.getProduct);
  var id = R.compose(R.propOr(null, 'id'), R.or({}));
  return {
    id,
    isLoading,
    details,

    /**
     * Request products by passed id.
     * Used for created gift, for fetching product details.
     * Can be called without giftId argument if hook called inside SendGiftModule scope.
     *
     * @namespace
     * @param {Object} options
     * @prop {number} options.productId - Id of product that should be requested.
     * @prop {number} options.giftId - Gift id by which product will be requested.
     */
    fetchByGift: (0, _react.useCallback)(function (_ref) {
      var productId = _ref.productId,
          giftId = _ref.giftId;
      return dispatch((0, _marketplace2.loadProductRequest)({
        productId,
        giftId
      }));
    }, [dispatch])
  };
};

exports.useProductReview = useProductReview;